/* eslint-disable no-compare-neg-zero */
/* eslint-disable func-names */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import ResizeObserver from 'react-resize-observer';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'emotion-theming';
import useCalendar from './hooks/useCalendar';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import Input from '../../../../shared/_TBComponents/Input/index';
import SelectBox from '../../../../shared/_TBComponents/SelectBox';
import MultipleChoiceQuestionsFormInputs from './MultipleChoiceQuestionsFormInputs';
import {
  createQuestionForAccount, updateQuestionForAccount, updateQuestionChoice,
  createQuestionChoice, deleteQuestionChoice, reorderQuestionChoices,
  fetchQuestionsForAccount, setQuestionCount,
} from '../../ducks/calendarActions';
import { showErrorToast, showSuccessToast } from '../../../../shared/utils/toastManager';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

export const getQuestionCreatePayload = (baseValues, description) => {
  const updatedValues = Object.entries(baseValues).reduce((acc, [key, value]) => {
    if (
      value !== ''
      && value !== null
      && !(Array.isArray(value) && value.length === 0)
      && !(value && typeof value === 'object' && Object.keys(value).length === 0)
    ) {
      acc[key] = value;
    }
    return acc;
  }, {});

  updatedValues.description = description || '';
  return updatedValues;
};

const colorPickerOptions = [
  {
    backgroundColor: '#D16D6A',
    icon: null,
  },
  {
    backgroundColor: '#F9DA78',
    icon: null,
  },
  {
    backgroundColor: '#9DC384',
    icon: null,
  },
  {
    backgroundColor: 'white',
    icon: 'opt-out',
    iconColor: '#9E9E9E',
  },
];

const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px;
  width: 88vw;
  max-width: 1000px;
`;

const SpinnerWrapper = styled('div')`
.spinner-container {
  min-height: 500px;
}
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-top: 6px
;  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${(props) => props.backgroundColor};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${(props) => props.backgroundColor};
  transition: ${TransitionGlobal};
  ${(props) => !props.disabled && 'cursor: pointer;'}
  ${(props) => !props.disabled && ':hover { opacity: 0.7; }'}
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  border: 2px solid ${({ theme }) => theme.colors.text};
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndTypeWrapper = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surfaceInput};
  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

const DescriptionContainer = styled('div')`
display: flex;
flex-direction: column;
height: 100%;
`;

const ThresholdsTextContainer = styled('div')`
display: flex;
gap: 4px;
flex-direction: column;
`;

const InputTypeMinAndMaxContainer = styled('div')`
display: flex;
gap: 16px;
flex-wrap: ${(props) => props.containerWidth < 570 && 'wrap'};
margin-bottom: ${(props) => props.addMarginBottom && '100px'};
`;

const ThresholdRow = styled('div')`
display: flex;
gap: 16px;
flex-wrap: wrap;
`;

const ThresholdInversionRow = styled('label')`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .checkbox-input {
    appearance: none;
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: ${TransitionGlobal};
  }

  .checkbox-input:checked {
    border: 2px solid #77A7FF;
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid #77A7FF;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const ReportingOptionsRow = styled('div')`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const ColorPickerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;

const ColorPicker = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 47px;
  max-width: 47px;
  min-height: 38px;
  max-height: 38px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 4px;
  cursor: pointer;
  background-color: ${(props) => props.backgroundColor};
`;

const ColorPickerRow = styled('div')`
  display: flex;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  background-color: white;
`;

const ColorBlock = styled('div')`
  min-height: 24px;
  max-height: 24px;
  min-width: 24px;
  max-width: 24px;
  background-color: ${(props) => props.backgroundColor};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${(props) => (props.backgroundColor ? 'none' : '1px solid #77A7FF')};
`;

const ColorPickerTooltip = styled(ReactTooltip)`
  background-color: white !important;
  opacity: 1 !important;
  padding: 0 !important;
  box-shadow: 0px 0px 1px 0px #3031330D, 0px 4px 8px 0px #3031331A;
  font-family: 'Nunito Sans' !important;
  font-size: 13px !important;
`;

const getQuestionChoice = (choices, answer) => {
  const normalizedAnswer = answer.toLowerCase();
  return (choices || []).find((choice) => (
    [choice.value, choice.displayValue].some((choiceValue) => (
      typeof choiceValue === 'string' && choiceValue.toLowerCase() === normalizedAnswer
    ))
  ));
};

const getQuestionChoiceColor = (choices, answer) => getQuestionChoice(choices, answer)?.color || '';

const ReportingColorPicker = ({
  fieldName, label, setFieldValue, value,
}) => {
  const tooltipRef = useRef(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const tooltipId = `color-picker-${fieldName}`;

  const handleColorPickerClick = () => {
    setTooltipVisible((isVisible) => !isVisible);
  };

  const handleColorOptionClick = (event) => {
    const selectedColor = event.currentTarget.dataset.color;
    setFieldValue(fieldName, selectedColor === 'white' ? '' : selectedColor);
    setTooltipVisible(false);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setTooltipVisible(false);
    }
  };

  useEffect(() => {
    if (tooltipVisible) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [tooltipVisible]);

  return (
    <ColorPickerWrapper>
      <Text fontWeight={700} fontSize='16px'>{label}</Text>
      <ColorPicker
        backgroundColor={value || 'white'}
        onClick={handleColorPickerClick}
        data-tooltip-id={tooltipId}
      >
        {(value === 'white' || !value) && (
          <IcomoonReact
            iconSet={iconSet}
            size={20}
            icon='opt-out'
            color='#9E9E9E'
          />
        )}
      </ColorPicker>
      {tooltipVisible && (
        <ColorPickerTooltip
          clickable
          isOpen
          opacity={1}
          id={tooltipId}
          place='top'
          content={(
            <ColorPickerRow ref={tooltipRef}>
              {colorPickerOptions.map((colorOption) => (
                <ColorBlock
                  key={colorOption.backgroundColor}
                  backgroundColor={colorOption.backgroundColor}
                  data-color={colorOption.backgroundColor}
                  onClick={handleColorOptionClick}
                >
                  {colorOption.icon && (
                    <IcomoonReact
                      iconSet={iconSet}
                      size={20}
                      icon='opt-out'
                      color='#9E9E9E'
                    />
                  )}
                </ColorBlock>
              ))}
            </ColorPickerRow>
          )}
        />
      )}
    </ColorPickerWrapper>
  );
};

ReportingColorPicker.propTypes = {
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  value: PropTypes.string,
};

ReportingColorPicker.defaultProps = {
  value: '',
};

const NewQuestionForm = ({ closeModal }) => {
  const dispatch = useDispatch();
  const {
    handleGetCreatNewQuestionFormValidationSchema,
    handleGetCustomSelectStylesForNewQuestionDropdown,
  } = useCalendar();
  const typeSelectRef = useRef(null);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);
  const questionCount = useSelector((state) => state.calendar.data.questionCount);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { colors } = useTheme();
  const accountCode = currentUser?.accountCode;
  const secondLayerModalData = useSelector((state) => state.calendar.data.secondLayerModalData);
  const editQuestion = secondLayerModalData?.editQuestion;
  const isEdit = !!editQuestion;
  /** API question objects carry inputType as a string; the form values use the
   * numeric codes. */
  const INPUT_TYPE_NUM = {
    RANGE: 0, INPUT: 1, 'YES-NO': 2, 'MULTIPLE-CHOICE': 3,
  };
  const editInputType = isEdit ? INPUT_TYPE_NUM[editQuestion.inputType] : null;
  const savedChoicesRef = useRef(isEdit ? [...(editQuestion.choices || [])] : []);
  const needsOrderRef = useRef(false);
  const createdChoiceIdsRef = useRef({});

  const runQuestionAction = (action, ...args) => new Promise((resolve, reject) => {
    dispatch(action(...args, { onSuccess: resolve, onError: reject }));
  });

  const isSubmitDisabled = (errors, touched, isSubmitting) => {
    /** Edit opens with a valid existing record, so don't hold the button
     * hostage to the create-flow's "touch something first" gate. */
    if (isEdit) {
      return Object.keys(errors).length > 0 || isSubmitting;
    }
    if ((Object.keys(errors).length > 0 && Object.keys(touched).length > 0) || Object.keys(touched).length === 0 || isSubmitting) {
      return true;
    }
    return false;
  };

  const handleMarkAllTouched = (formValues, setTouched) => {
    setTouched(
      Object.keys(formValues).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {}),
    );
  };

  const handleResetTouched = (setTouched) => {
    setTouched({});
  };

  const inputTypeOptions = (values) => ([
    {
      name: 'Range Slider',
      id: 0,
      includeCheckmark: values.inputType === 0,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Input Box',
      id: 1,
      includeCheckmark: values.inputType === 1,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Multiple Choice',
      id: 3,
      includeCheckmark: values.inputType === 3,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Yes/No',
      id: 2,
      includeCheckmark: values.inputType === 2,
      checkmarkColor: colors.textTertiary,
    },
  ]);

  return (
    <Formik
      initialValues={{
        name: isEdit ? (editQuestion.title || '') : '',
        abbreviation: isEdit ? (editQuestion.abbr || '') : '',
        description: isEdit ? (editQuestion.description || '') : '',
        inputType: isEdit ? editInputType : 0,
        minimum: isEdit && editQuestion.minRangeValue != null ? editQuestion.minRangeValue : 0,
        maximum: isEdit && editQuestion.maxRangeValue != null ? editQuestion.maxRangeValue : 5,
        upperThreshold: isEdit && editQuestion.thresholdEnabled ? editQuestion.thresholdUpperLimit : null,
        lowerThreshold: isEdit && editQuestion.thresholdEnabled ? editQuestion.thresholdLowerLimit : null,
        thresholdInverted: isEdit ? !!editQuestion.thresholdInverted : false,
        yesColor: isEdit ? getQuestionChoiceColor(editQuestion.choices, 'Yes') : '',
        noColor: isEdit ? getQuestionChoiceColor(editQuestion.choices, 'No') : '',
        choiceValue: '',
        choiceColor: '',
        choiceNumericalWeight: '',
        choiceOrder: null,
        /** Choices use their own endpoints, but edit validation needs the stored rows. */
        choicesArray: isEdit ? (editQuestion.choices || []) : [],
      }}
      validationSchema={handleGetCreatNewQuestionFormValidationSchema()}
          onSubmit={async (values, { setSubmitting, setFieldValue, errors }) => {
            if (isEdit) {
              if (values.inputType === 3 && values.choicesArray.some((choice) => !(choice.displayValue || '').trim())) {
                showErrorToast('Enter a label for every option');
                setSubmitting(false);
                return;
              }
              const payload = {
                title: values.name,
                abbr: values.abbreviation,
                description: values.description,
                thresholdInverted: !!values.thresholdInverted,
              };
              if (values.inputType === 0) {
                payload.minRangeValue = parseInt(values.minimum, 10);
                payload.maxRangeValue = parseInt(values.maximum, 10);
                if (values.lowerThreshold !== null && values.lowerThreshold !== '') {
                  payload.thresholdLowerLimit = parseInt(values.lowerThreshold, 10);
                  /** The schema rejects null — an empty upper is sent as 0, which
                   * stores "no upper segment" (lower-only threshold). */
                  payload.thresholdUpperLimit = values.upperThreshold !== null && values.upperThreshold !== ''
                    ? parseInt(values.upperThreshold, 10)
                    : 0;
                } else if (editQuestion.thresholdEnabled) {
                  /** thresholds were set and the user cleared them */
                  payload.thresholdEnabled = false;
                }
              }
              const editableChoices = [
                { answer: 'Yes', color: values.yesColor },
                { answer: 'No', color: values.noColor },
              ];
              const changedChoices = editableChoices
                .map(({ answer, color }) => ({
                  choice: getQuestionChoice(editQuestion.choices, answer),
                  color,
                }))
                .filter(({ choice, color }) => choice && color !== (choice.color || ''));
              setSubmitting(true);
              try {
                await new Promise((resolve, reject) => {
                  dispatch(updateQuestionForAccount(accountCode, editQuestion.id, payload, {
                    onSuccess: resolve,
                    onError: reject,
                    suppressSuccessToast: true,
                  }));
                });
                if (values.inputType === 2) {
                  await changedChoices.reduce((pending, { choice, color }) => pending.then(() => (
                    runQuestionAction(updateQuestionChoice, accountCode, editQuestion.id, choice.id, { color: color || null })
                  )), Promise.resolve());
                }
                if (values.inputType === 3) {
                  const choices = [...values.choicesArray];
                  const savedChoices = savedChoicesRef.current;
                  const originalOrder = [...savedChoices].sort((a, b) => a.order - b.order).map((choice) => choice.id);
                  await choices.reduce((pending, choice) => pending.then(async () => {
                    const saved = savedChoices.find((item) => item.id === choice.id);
                    if (saved) {
                      const changes = {};
                      if (choice.displayValue !== saved.displayValue) changes.displayValue = choice.displayValue;
                      if ((choice.color || null) !== (saved.color || null)) changes.color = choice.color || null;
                      if ((choice.numericalWeight ?? null) !== (saved.numericalWeight ?? null)) changes.numericalWeight = choice.numericalWeight ?? null;
                      if (Object.keys(changes).length) {
                        const updated = await runQuestionAction(updateQuestionChoice, accountCode, editQuestion.id, choice.id, changes);
                        savedChoicesRef.current = savedChoicesRef.current.map((item) => (item.id === choice.id ? updated : item));
                      }
                    }
                  }), Promise.resolve());
                  await choices.reduce((pending, choice) => pending.then(async () => {
                    if (!savedChoicesRef.current.some((item) => item.id === choice.id)) {
                      const newChoice = { displayValue: choice.displayValue };
                      if (choice.color) newChoice.color = choice.color;
                      if (choice.numericalWeight != null) newChoice.numericalWeight = choice.numericalWeight;
                      const created = await runQuestionAction(createQuestionChoice, accountCode, editQuestion.id, newChoice);
                      createdChoiceIdsRef.current[choice.id] = created.id;
                      choices[choices.indexOf(choice)] = { ...choice, id: created.id };
                      savedChoicesRef.current = [...savedChoicesRef.current, created];
                      needsOrderRef.current = true;
                      setFieldValue('choicesArray', choices);
                    }
                  }), Promise.resolve());
                  await [...savedChoicesRef.current].reduce((pending, choice) => pending.then(async () => {
                    if (!choices.some((item) => item.id === choice.id)) {
                      await runQuestionAction(deleteQuestionChoice, accountCode, editQuestion.id, choice.id);
                      savedChoicesRef.current = savedChoicesRef.current.filter((item) => item.id !== choice.id);
                      needsOrderRef.current = true;
                    }
                  }), Promise.resolve());
                  const choiceIds = choices.map((choice) => choice.id);
                  if (needsOrderRef.current || choiceIds.some((id, index) => id !== originalOrder[index])) {
                    await runQuestionAction(reorderQuestionChoices, accountCode, editQuestion.id, choiceIds);
                    savedChoicesRef.current = savedChoicesRef.current.map((choice) => ({
                      ...choice, order: choiceIds.indexOf(choice.id),
                    }));
                    needsOrderRef.current = false;
                  }
                }
                dispatch(fetchQuestionsForAccount(accountCode));
                showSuccessToast('Question updated');
                closeModal();
              } catch (error) {
                dispatch(fetchQuestionsForAccount(accountCode));
              } finally {
                setSubmitting(false);
              }
              return;
            }
            /** returns an updated formatted values object based on type */
            const baseValues = {
              title: values.name,
              abbr: values.abbreviation,
              description: values.description,
              inputType: values.inputType,
              minRangeValue: values.inputType === 0 ? parseInt(values.minimum, 10) : null,
              maxRangeValue: values.inputType === 0 ? parseInt(values.maximum, 10) : null,
              /** Each limit only when it has a value — null/NaN entries are
               * stripped below and the schema rejects non-numbers. */
              thresholdLowerLimit: values.lowerThreshold !== null && values.lowerThreshold !== ''
                ? parseInt(values.lowerThreshold, 10) : null,
              thresholdUpperLimit: values.upperThreshold !== null && values.upperThreshold !== ''
                ? parseInt(values.upperThreshold, 10) : null,
              thresholdInverted: !!values.thresholdInverted,
              choices: values.inputType === 2 && (values.yesColor || values.noColor)
                ? [
                  { value: 'Yes', ...(values.yesColor ? { color: values.yesColor } : {}) },
                  { value: 'No', ...(values.noColor ? { color: values.noColor } : {}) },
                ]
                : values.choicesArray,
            };

            /** Build and return the final object, excluding any properties with empty values */
            const updatedValues = getQuestionCreatePayload(baseValues, values.description);

            if (!errors) {
              setSubmitting(true);
            }

            /** create new question for account with error handling */
            dispatch(createQuestionForAccount(accountCode, updatedValues, {
              onSuccess: (response) => {
                setSubmitting(false);
                /** add question to question count in create questionnaire form inputs */
                dispatch(setQuestionCount([
                  ...questionCount,
                  {
                    index: questionCount.length,
                    id: response.id,
                    isNullValue: false,
                    isVisible: true,
                    // isVisible: false, /** need this to handle fade in and out */
                  },
                ]));
                /** call to reload question with new question included */
                dispatch(fetchQuestionsForAccount(accountCode));
                closeModal();
              },
              onError: () => {
                setSubmitting(false);
                showErrorToast('Opps! Something went wrong. Unable to create new exercise.');
              },
            }));
          }}
          render={({
            errors,
            touched,
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            handleBlur,
            setFieldTouched,
            setFieldError,
            isSubmitting,
            validateForm,
            setTouched,
            setErrors,
          }) => (
            <Form>
              <FormWrapper>
                <Text fontWeight={700} fontSize='24px'>{isEdit ? ' Edit Question' : ' New Question'}</Text>
                {isSubmitting ? (
                  <SpinnerWrapper>
                    <Spinner />
                  </SpinnerWrapper>
                ) : (
                  <>
                    <ResizeObserver
                        onResize={(rect) => {
                          setContainerWidth(rect?.width);
                        }}
                    />
                    <NameAndTypeWrapper>
                      <Input
                          error={!!touched.name && !!errors.name}
                          errorMsg={errors.name}
                          fontSize='16px'
                          fontWeight={400}
                          height='38px'
                          label='Add New Question'
                          name='name'
                          onChange={(value) => {
                            handleChange(value);
                          }}
                          onBlur={handleBlur}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.name}
                          width='100%'
                          placeholder={containerWidth < 308 ? 'Enter Question' : 'Enter question/feedback request'}
                      />
                      <div style={{ display: 'flex', minWidth: containerWidth < 527 ? '100%' : '200px' }} ref={typeSelectRef}>
                        <Input
                          textTransformUppercase
                          error={!!touched.abbreviation && !!errors.abbreviation}
                          errorMsg={errors.abbreviation}
                          fontSize='16px'
                          fontWeight={400}
                          height='38px'
                          label='Abbreviation'
                          name='abbreviation'
                          onChange={(value) => {
                            handleChange(value);
                          }}
                          onBlur={handleBlur}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.abbreviation}
                          width='100%'
                          placeholder='i.e. ABR'
                        />
                      </div>
                    </NameAndTypeWrapper>
                    <DescriptionContainer>
                      <Text fontSize='16px' fontWeight={700}>
                        Description
                      </Text>
                      <Field
                        name='description'
                        className='form-control'
                        render={({ field }) => (
                          <StyledTextArea {...field} />
                        )}
                      />
                      {errors.description && touched.description && (
                        <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
                      )}
                    </DescriptionContainer>
                    <InputTypeMinAndMaxContainer containerWidth={containerWidth} addMarginBottom={values.inputType === 1}>
                      <SelectBox
                        options={inputTypeOptions(values)}
                        value={inputTypeOptions(values).find((option) => option.id === values.inputType)}
                        onChangeFunction={(option) => {
                          setFieldValue('inputType', option.id);
                          handleResetTouched(setTouched);
                        }}
                        onBlur={() => setFieldTouched('inputType', true)}
                        error={!!touched.inputType && !!errors.inputType}
                        errorMsg={errors.inputType}
                        title='Input Type'
                        titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                        customStyles={handleGetCustomSelectStylesForNewQuestionDropdown()}
                        isClearable={false}
                        isDisabled={isEdit}
                        styledProps={{ height: '', maxWidth: 468 }}
                        width='100%'
                        styledPropsInput={{
                          width: '100% !important',
                        }}
                      />
                      {values.inputType === 0 && (
                        <>
                          <Input
                            error={!!touched.minimum && !!errors.minimum}
                            errorMsg={errors.minimum}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Minimum'
                            name='minimum'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth > 850 ? 226 : 120,
                            }}
                            top='38px'
                            value={values.minimum}
                            width='100%'
                          />
                          <Input
                            error={!!touched.maximum && !!errors.maximum}
                            errorMsg={errors.maximum}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Maximum'
                            name='maximum'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth > 850 ? 226 : 120,
                            }}
                            top='38px'
                            value={values.maximum}
                            width='100%'
                          />
                        </>
                      )}
                    </InputTypeMinAndMaxContainer>
                    {values.inputType === 0 && (
                      <>
                        <ThresholdsTextContainer>
                          <Text fontSize='16px' fontWeight={700}>Thresholds (Optional)</Text>
                          <Text fontSize='16px' fontStyle='italic' color={colors.textSecondary}>Set an upper and a lower limit to report 3 separate segments (i.e. For the question “How many hours did you sleep?”, setting a Lower Threshold of 5  and an Upper Threshold of 7 will result in 3 segments: 1-5 hours will be  “unsatisfactory”, 5-7 hours as “satisfactory”, and 8+ hours as “excellent”).</Text>
                        </ThresholdsTextContainer>
                        <ThresholdRow>
                          <Input
                            error={!!touched.lowerThreshold && !!errors.lowerThreshold}
                            errorMsg={errors.lowerThreshold}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Lower Threshold'
                            name='lowerThreshold'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth < 675 ? 136 : 226,
                              maxWidth: containerWidth > 516 && 226,
                            }}
                            top='38px'
                            value={values.lowerThreshold}
                            width='100%'
                          />
                          <Input
                            error={!!touched.upperThreshold && !!errors.upperThreshold}
                            errorMsg={errors.upperThreshold}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Upper Threshold'
                            name='upperThreshold'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth < 675 ? 136 : 226,
                              maxWidth: containerWidth > 516 && 226,
                            }}
                            top='38px'
                            value={values.upperThreshold}
                            width='100%'
                          />
                        </ThresholdRow>
                        <ThresholdInversionRow>
                          <input
                            type='checkbox'
                            className='checkbox-input'
                            checked={values.thresholdInverted}
                            onChange={(event) => {
                              setFieldValue('thresholdInverted', event.target.checked);
                            }}
                          />
                          <Text fontSize='16px'>Invert thresholds (values below the lower threshold are preferred)</Text>
                        </ThresholdInversionRow>
                      </>
                    )}
                    {values.inputType === 3 && (
                      <MultipleChoiceQuestionsFormInputs
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      containerWidth={containerWidth}
                      handleBlur={handleBlur}
                      initialChoices={isEdit ? editQuestion.choices || [] : []}
                      isEdit={isEdit}
                      createdChoiceIds={createdChoiceIdsRef}
                      />
                    )}
                    {values.inputType === 2 && (
                      <ThresholdsTextContainer>
                        <Text fontSize='16px' fontWeight={700}>Reporting options</Text>
                        <ReportingOptionsRow>
                          <ReportingColorPicker
                            fieldName='yesColor'
                            label='Yes'
                            setFieldValue={setFieldValue}
                            value={values.yesColor}
                          />
                          <ReportingColorPicker
                            fieldName='noColor'
                            label='No'
                            setFieldValue={setFieldValue}
                            value={values.noColor}
                          />
                        </ReportingOptionsRow>
                      </ThresholdsTextContainer>
                    )}
                  </>
                )}
                <ButtonsContainer ref={containerRef}>
                  <SaveButton
                      onClick={() => {
                        if (isSubmitDisabled(errors, touched, isSubmitting)) {
                          handleMarkAllTouched(values, setTouched);
                          validateForm();
                        } else {
                          handleSubmit();
                        }
                      }}
                      backgroundColor={isSubmitDisabled(errors, touched, isSubmitting) ? colors.buttonDisabledBg : colors.buttonPrimaryBg}
                      disabled={isSubmitDisabled(errors, touched, isSubmitting)}
                  >
                    <Text color={colors.white} fontSize='16px' fontWeight={700}>{isEdit ? 'SAVE CHANGES' : 'SAVE AND ADD'}</Text>
                  </SaveButton>
                  <CancelButton onClick={() => {
                    closeModal();
                  }}
                  >
                    <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
                  </CancelButton>
                </ButtonsContainer>
              </FormWrapper>
            </Form>
          )}
    />
  );
};

export default NewQuestionForm;
